import { ProductInformationForm } from '@partials/forms/product-detail/product-information'

export type IProductInformationTab = Parameters<
  typeof ProductInformationForm
>[0]

export const ProductInformationTab = ({ onError }: IProductInformationTab) => {
  return <ProductInformationForm onError={onError} />
}
